module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/cover-illust-2f6f039478b85eb1fe9ca625343e55a3.svg";